module.exports = __webpack_public_path__ + "img/ic-invoice-black.25c915ab.svg";